import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";

interface Props {
  airportCode: string;
}

const AirportTitle = ({ airportCode }: Props) => {
  const airports = useSelector(
    (state: AppState) => state.storage.airportDestinations
  );
  const airportTitle = airports.find((airport) => airport.Code === airportCode);
  if (airportTitle === undefined) {
    return null;
  }
  return (
    <span>
      <b>{airportTitle.$t}</b> ({airportCode})
    </span>
  );
};

export default AirportTitle;
